import getItemStyles from '../../../utils/item-styles';
import moment from 'moment';
import fixAmAndPm from '../../../../../utils/fixAmAndPm';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck';

/**
 * Returns a meal item that can be displayed in the seven to nine day schedule. It will be displayed in the day of the
 * parent tour's start time. The styling will be created by calling getItemStyle.
 * @param {*} rId
 * @param {*} dayType
 */
const generateMeal = (rId, dayType, tourStartTime, timeOffset, startDate, scheduleType, scheduleFormat, scheduleLength) => {
  const { rdtId, tour } = dayType;
  const { meal } = tour;
  const { mealId, red, mealTime, mealEndTime, isApproved } = meal;
  const mealStyle = getItemStyles('meal');
  // const mealStartTime = moment(moment.unix(mealTime)).add(timeOffset, 'minutes');
  // const endTime = moment(moment.unix(mealEndTime)).add(timeOffset, 'minutes');

  const mealStartTime = moment.unix(mealTime);
  const endTime = moment.unix(mealEndTime);

  let DSTNeutralMealStartTime = moment.utc(mealStartTime).clone();
  let DSTNeutralMealEndTime = moment.utc(endTime).clone();

  const adjustedMeal = {
    id: mealId,
    rdtId,
    group: rId,
    itemType: 'meal',
    start_time: moment(tourStartTime).startOf('day'),
    end_time: moment(tourStartTime).endOf('day'),
    title: fixAmAndPm(moment(DSTNeutralMealStartTime).format('h:mma')) + '-'
      + fixAmAndPm(moment(DSTNeutralMealEndTime).format('h:mma')),
    backgroundColor: meal.isApproved ? 'gray': red ? 'red' : mealStyle.backgroundColor,
    color: 'black',
    borderStyle: mealStyle.borderStyle,
    borderColor: mealStyle.borderColor,
    isApproved
  };
  return adjustedMeal;
}

export default generateMeal;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generateMeal.js